import Axios from "../../connection/defaultClient";
import * as offlineActions from "./types";
export const sendOfflinePayment = (payload, onSuccess=()=>{},onFail=()=>{}) => {
  return (dispatch) => {
    dispatch({
      type: offlineActions.GET_OFFLINEPAYMENT_LOADING,
      payload: true,
    });
    Axios.post(`/OfflinePayment/CreateOfflinePaymentDetails`,payload)
      .then((response) => {
        
        dispatch({
          type: offlineActions.GET_OFFLINE_SUCCESS,
          payload: response.data.data,
        })
        if (response.data.state == 1) {
          onSuccess(response.data);
        } else if (response.data.state == -1) {
          onFail(response.data);
        }
      })
      .catch((error) => {
        dispatch({
          type: offlineActions.GET_OFFLINE_FAIL,
          payload: error.message,
        });
      });
  };
};
export const GetOfflinePayment = () => {
  return (dispatch) => {
    dispatch({
      type: offlineActions.GET_ALLOFFLINEPAYMENT_LOADING,
      payload: true,
    });
    Axios.get(`/OfflinePayment/GetAllOfflinePayment`)
      .then((response) => {
        dispatch({
          type: offlineActions.GET_ALLOFFLINE_SUCCESS,
          payload: response.data.data,
        });
      })
      .catch((error) => {
        dispatch({
          type: offlineActions.GET_ALLOFFLINE_FAIL,
          payload: error.message,
        });
      });
  };
};




